import { useAccount } from "wagmi";

import { useIsSupportedChain } from "shared/providers/wagmi";

import { StakingOcxInfo } from "./useStakingOcxInfo";

type Status = "connectWallet" | "switchNetwork" | "nothingToClaim" | "claim";

export const useClaimOcxStatus = (stakingOcxInfo: StakingOcxInfo) => {
  const { isConnected } = useAccount();
  const isSupported = useIsSupportedChain();

  const getStatus = (): Status => {
    if (!isConnected) return "connectWallet";
    if (!isSupported) return "switchNetwork";
    if (
      stakingOcxInfo?.rewardsAvailableCA &&
      stakingOcxInfo?.rewardsAvailableCA.lessThanOrEqual(0)
    )
      return "nothingToClaim";

    return "claim";
  };

  const status = getStatus();

  const getBtnText = () => {
    if (status === "nothingToClaim") return "No rewards";
    if (status === "claim") return "Claim";
  };

  return {
    status,
    btnText: getBtnText(),
    btnDisabled:
      status === "nothingToClaim" || !stakingOcxInfo?.rewardsAvailableCA,
  };
};
